import { CircularProgress, useMediaQuery } from "@mui/material";
import { Link } from "react-router-dom";
import { urlPoliticaSegura, usePoliticaPrivacidad } from "../hooks/usePoliticaPrivacidad";

const formatearFecha = (iso: string | null | undefined): string | null => {
    if (!iso) return null;
    const fecha = new Date(iso);
    return Number.isNaN(fecha.getTime())
        ? null
        : fecha.toLocaleDateString("es-AR", { day: "2-digit", month: "long", year: "numeric" });
};

export default function PoliticaPrivacidadPage() {
    const isSmall = useMediaQuery("(max-width:900px)");
    // Siempre la versión más reciente: no se muestra un PDF viejo si acaban de reemplazarlo.
    const { cargando, politica, error } = usePoliticaPrivacidad(true);

    const url = urlPoliticaSegura(politica?.url);
    const fecha = formatearFecha(politica?.fechaActualizacion);

    const boton = {
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "13px 22px",
        borderRadius: 999,
        background: "#00629c",
        color: "#ffffff",
        fontSize: 14,
        fontWeight: 600,
        textDecoration: "none",
    } as const;

    return (
        <main style={{ position: "relative", zIndex: 2 }}>
            <section style={{ padding: isSmall ? "16px 16px 0" : "24px 32px 0" }}>
                <div
                    style={{
                        borderRadius: isSmall ? 24 : 32,
                        background:
                            "linear-gradient(130deg, #001f33 0%, #003A5C 45%, #005A8C 100%)",
                        padding: isSmall ? "40px 28px" : "56px 72px",
                        position: "relative",
                        overflow: "hidden",
                    }}
                >
                    <div
                        style={{
                            fontSize: 11,
                            fontWeight: 700,
                            letterSpacing: "0.16em",
                            textTransform: "uppercase",
                            color: "#cfe5ff",
                            marginBottom: 12,
                        }}
                    >
                        Información legal
                    </div>
                    <h1
                        style={{
                            fontSize: isSmall ? 34 : 52,
                            fontWeight: 700,
                            letterSpacing: "-0.03em",
                            lineHeight: 1.05,
                            color: "#ffffff",
                            margin: 0,
                        }}
                    >
                        Política de privacidad
                    </h1>
                    {fecha && (
                        <p
                            style={{
                                fontSize: 15,
                                color: "rgba(255,255,255,0.55)",
                                marginTop: 14,
                                marginBottom: 0,
                            }}
                        >
                            Última actualización: {fecha}
                        </p>
                    )}
                </div>
            </section>

            <section style={{ padding: isSmall ? "32px 16px 64px" : "48px 32px 80px" }}>
                {cargando ? (
                    <div style={{ display: "flex", justifyContent: "center", padding: "64px 0" }}>
                        <CircularProgress aria-label="Cargando la política de privacidad" />
                    </div>
                ) : url ? (
                    <div style={{ maxWidth: 1120, margin: "0 auto", display: "grid", gap: 20 }}>
                        <div
                            style={{
                                display: "flex",
                                flexWrap: "wrap",
                                alignItems: "center",
                                gap: 12,
                            }}
                        >
                            <a href={url} target="_blank" rel="noopener noreferrer" style={boton}>
                                Abrir PDF en otra pestaña
                            </a>
                            {politica?.nombreArchivo && (
                                <span style={{ fontSize: 13, color: "var(--ink-500)" }}>
                                    {politica.nombreArchivo}
                                </span>
                            )}
                        </div>

                        {/* En celulares el navegador no embebe bien los PDF: ahí queda solo el botón. */}
                        {!isSmall && (
                            <iframe
                                src={url}
                                title="Política de privacidad"
                                style={{
                                    width: "100%",
                                    height: "80vh",
                                    minHeight: 520,
                                    border: "1px solid rgba(191,199,210,0.5)",
                                    borderRadius: 16,
                                    background: "#ffffff",
                                }}
                            />
                        )}
                    </div>
                ) : (
                    <div
                        role="status"
                        style={{
                            maxWidth: 560,
                            margin: "0 auto",
                            textAlign: "center",
                            padding: "48px 24px",
                            borderRadius: 24,
                            border: "1px solid rgba(191,199,210,0.5)",
                        }}
                    >
                        <p
                            style={{
                                fontSize: 17,
                                fontWeight: 600,
                                color: "var(--ink-900)",
                                margin: "0 0 8px",
                            }}
                        >
                            {error
                                ? "No pudimos cargar la política de privacidad."
                                : "Todavía no publicamos nuestra política de privacidad."}
                        </p>
                        <p
                            style={{
                                fontSize: 14,
                                lineHeight: 1.6,
                                color: "var(--ink-500)",
                                margin: "0 0 24px",
                            }}
                        >
                            {error
                                ? "Probá de nuevo en unos minutos."
                                : "Volvé a visitarnos pronto."}
                        </p>
                        <Link to="/" style={boton}>
                            Volver al inicio
                        </Link>
                    </div>
                )}
            </section>
        </main>
    );
}
